import Button from 'Components/UI_Library/FormElements/Button';
import classes from './NotificationAction.module.css';

type Props = {
    notification: {
        type: 'danger' | 'success' | 'warning' | 'info';
        message: string;
        action?: {
            text: string;
            url: string;
        };
    };
};

/** @deprecated NotificationAction is just used for subscription notifications. It should not be further used and preferably removed */
const NotificationAction = (props: Props) => {
    const { notification } = props;

    return (
        <div className={classes.container}>
            <div className={classes.notificationMessage}>
                <span className={notification.type ? classes[notification.type] : ''}>{notification.message}</span>
                {notification.action && (
                    <Button type="darkNavy" text={notification.action.text} href={notification.action.url} />
                )}
            </div>
        </div>
    );
};

export default NotificationAction;
